import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';

import { Observable } from 'rxjs';

import { AuthService } from '@services/auth/auth.service';
import { LoadingSpinnerService } from '@services/loading-spinner/loading-spinner.service';

const requests: HttpRequest<any>[] = [];
let observer: MutationObserver | null = null;

export const loaderInterceptorFn: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const loaderService = inject(LoadingSpinnerService);
  const authService = inject(AuthService);

  requests.push(req);
  loaderService.isLoading.next(true);

  return new Observable<HttpEvent<any>>(observerSub => {
    const subscription = next(req).subscribe({
      next: event => {
        if (event instanceof HttpResponse) {
          if (req.url.includes('api/v1/Customer/GetCustomerShortInfo')) {
            setNonceToScripts(event);
          }

          removeRequest(req, loaderService);
          observerSub.next(event);
        }
      },
      error: (err: any) => {
        removeRequest(req, loaderService);

        if (err instanceof HttpErrorResponse) {
          if (req.url.includes('api/v1/Customer/GetCustomerShortInfo') && err.headers) {
            setNonceToScripts(err as any);
          }

          if (err.status === 401) {
            console.warn('Unauthorized request detected. Redirecting to login.');
            setTimeout(() => authService.login(), 500);
          } else if (err.status === 400 && req.url.includes('connect/token')) {
            setTimeout(() => authService.logout(), 500);
          }
        }

        observerSub.error(err);
      },
      complete: () => {
        removeRequest(req, loaderService);
        observerSub.complete();
      },
    });

    return () => {
      removeRequest(req, loaderService);
      subscription.unsubscribe();
    };
  });
};

// --- helpers ---
function removeRequest(req: HttpRequest<any>, loaderService: LoadingSpinnerService) {
  const i = requests.indexOf(req);
  if (i >= 0) {
    requests.splice(i, 1);
  }
  loaderService.isLoading.next(requests.length > 0);
}

function setNonceToScripts(response: HttpResponse<any>) {
  const cspHeader = response.headers.get('Content-Security-Policy');
  const match = cspHeader?.match(/'nonce-([^']+)'/);
  const nonce = match ? match[1] : null;

  if (nonce) {
    addNonceToScriptsAndStyles(nonce);
  } else {
    console.log('Nonce not found!');
  }
}

function addNonceToScriptsAndStyles(nonce: string) {
  document.querySelectorAll('script').forEach(script => {
    if (!script.hasAttribute('src') && !script.hasAttribute('nonce')) {
      script.setAttribute('nonce', nonce);
    }
  });

  if (observer) {
    observer.disconnect();
  }

  observer = new MutationObserver(() => {
    document.querySelectorAll('style').forEach(style => {
      if (!style.hasAttribute('nonce')) {
        style.setAttribute('nonce', nonce);
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
